import { render, staticRenderFns } from "./fenxiao.vue?vue&type=template&id=9de611c8&scoped=true"
import script from "./fenxiao.vue?vue&type=script&lang=js"
export * from "./fenxiao.vue?vue&type=script&lang=js"
import style0 from "./fenxiao.vue?vue&type=style&index=0&id=9de611c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de611c8",
  null
  
)

export default component.exports